import React from "react";
import PropTypes from "prop-types";

const FilterOptions = props => {
	const { children } = props;

	return <div className="filter-options">{children}</div>;
};

FilterOptions.propTypes = {
	children: PropTypes.node,
};

export default FilterOptions;
